<template>
  <div class="f-countdownHeader">
    <div class="container header">
      <div>
        <a href="http://www.alpine-space.eu/projects/alpfoodway/en/home" target="_blank">
          <img src="../../assets/alpfoodway_logo.png" class="alp-logo logo"/>
        </a>
      </div>
      <h3>The website is under construction</h3>
      <h3 class="slogan"><a href="https://twitter.com/search?q=%23alpfoodway&src=typd"
                    class="hyperref-style">#AlpFoodway</a></h3>
      <h4  class="slogan"> Safeguarding and valorising <br> the Alpine Food Cultural Heritage</h4>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CountdownHeader'
  }
</script>

<style scoped>

  .f-countdownHeader {
    position: relative;
    text-shadow: 2px 2px gray;

    /*position: fixed;*/
    /*top: 50%;*/
    /*margin-top: -33em;*/
    /*width: 100%;*/
    /*padding: 0;*/
  }

  .header {
    padding-top: 1%;
    text-align: center;
    color: white;
    border-bottom: 2px solid #ccc;
  }

  .header > div {
    font-weight: 200;
    background: rgba(250, 250, 250, 0.6);
    display: block;
    width: 13em;
    height: 13em;
    margin: 0 auto;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    border-radius: 100%;
    /*padding-top: 5.5%;*/
    cursor: pointer;
  }

  .header > h1 > a {
    color: #333;
    text-decoration: none;
    font-size: 16pt;
  }

  .header > h3 {
    margin: 20px 0;
  }

  .header > p {
    font-size: 1.5em;
  }

  .alp-logo {
    width: 200px;
    padding-top: 29%;
  }

  .hyperref-style {
    color: white;
  }

  .hyperref-style:hover {
    color: #c41c21;
  }

  .slogan{
    font-weight: bold;
    font-size: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/countdownComponents/CountdownHeader.vue